export default "{\n    \"defaultLabel\": \"Botón\"\n}\n"